import { connect } from 'react-redux'
import VariantSelect from './variant-select'

const mapStateToProps = state => {
  return {
    variantGroups: state.room.variantGroups,
  }
}
const mapDispatchToProps = null
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VariantSelect)
